import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

const LABELS = { challenges: "les courriels de défis", periods: "les résultats de période", weekly: "le récapitulatif hebdomadaire" };

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.post("/auth/email-unsubscribe", { token: params.get("token") || "" })
      .then(({ data }) => setState({ ok: true, cat: data.category })).catch((e) => setState({ error: errMsg(e) }));
  }, [params]);
  return (
    <div className="mpl-grain flex min-h-screen flex-col items-center justify-center gap-6 bg-[#0B1020] px-5 text-white" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <Logo />
      <div className="mpl-card max-w-md p-6 text-center" data-testid="unsubscribe-page">
        <MailX className="mx-auto text-[#B7F52A]" size={28} />
        {state.loading && <p className="mt-3 text-sm text-slate-300">Traitement…</p>}
        {state.ok && <p className="mt-3 text-sm text-slate-200" data-testid="unsubscribe-ok">C'est noté : vous ne recevrez plus {LABELS[state.cat]}. Vous pouvez changer d'avis dans vos paramètres.</p>}
        {state.error && <p className="mt-3 text-sm text-red-200" data-testid="unsubscribe-error">{state.error}</p>}
        <Link to="/connexion" className="mpl-btn-ghost mt-5">Ouvrir Ma Petite Ligue</Link>
      </div>
    </div>
  );
}
